import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Default_getInstance2tudkf86ziur0 as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { delay3147v9lzv1xxn as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { toLongOrNullutqivezb0wx1 as toLongOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  toNumber2e2hj9zugjwi2 as toNumber,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea9318j6pdzpd0vd as Result__exceptionOrNull_impl_p6xea9,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { canceldn4b3cdqcfny as cancel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { get_isSaved1yor47kvbhumv as get_isSaved } from './SaveBody.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import {
  ConnectTimeoutException35w4gpuoa1015 as ConnectTimeoutException,
  SocketTimeoutException2zstjwq2yf3s9 as SocketTimeoutException,
} from '../network/sockets/TimeoutExceptions.nonJvm.mjs';
import { HttpRequestTimeoutException19335ch7q7rkf as HttpRequestTimeoutException } from './HttpTimeout.mjs';
import {
  Send_instance2se4t9sd7p3bp as Send_instance,
  Sender1wtdgti85uk42 as Sender,
} from './api/CommonHooks.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  HttpRequest3fsc4149kgwfg as HttpRequest,
} from '../request/HttpRequest.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { OnRequestContext1tmu5b6bhlblg as OnRequestContext } from './api/KtorCallContexts.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return LOGGER;
}
var LOGGER;
function get_HttpRequestRetryEvent() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return HttpRequestRetryEvent;
}
var HttpRequestRetryEvent;
var HttpRequestRetry;
function get_MaxRetriesPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return MaxRetriesPerRequestAttributeKey;
}
var MaxRetriesPerRequestAttributeKey;
function get_ShouldRetryPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryPerRequestAttributeKey;
}
var ShouldRetryPerRequestAttributeKey;
function get_ShouldRetryOnExceptionPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryOnExceptionPerRequestAttributeKey;
}
var ShouldRetryOnExceptionPerRequestAttributeKey;
function get_ModifyRequestPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ModifyRequestPerRequestAttributeKey;
}
var ModifyRequestPerRequestAttributeKey;
function get_RetryDelayPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return RetryDelayPerRequestAttributeKey;
}
var RetryDelayPerRequestAttributeKey;
var HttpRetryEventDataClass;
function HttpRetryEventData() {
  if (HttpRetryEventDataClass === VOID) {
    class $ {
      constructor(request, retryCount, response, cause) {
        this.r5s_1 = request;
        this.s5s_1 = retryCount;
        this.t5s_1 = response;
        this.u5s_1 = cause;
      }
    }
    initMetadataForClass($, 'HttpRetryEventData');
    HttpRetryEventDataClass = $;
  }
  return HttpRetryEventDataClass;
}
function randomMs($this, randomizationMs) {
  return randomizationMs === 0n ? 0n : Default_getInstance().io(randomizationMs);
}
var HttpRequestRetryConfig$delay$slambdaClass;
function HttpRequestRetryConfig$delay$slambda() {
  if (HttpRequestRetryConfig$delay$slambdaClass === VOID) {
    class $ {
      *v5s(it, $completion) {
        yield* delay(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.v5s((!(p1 == null) ? typeof p1 === 'bigint' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpRequestRetryConfig$delay$slambdaClass = $;
  }
  return HttpRequestRetryConfig$delay$slambdaClass;
}
function HttpRequestRetryConfig$delay$slambda_0() {
  var i = new (HttpRequestRetryConfig$delay$slambda())();
  var l = (it, $completion) => i.v5s(it, $completion);
  l.$arity = 1;
  return l;
}
function HttpRequestRetryConfig$modifyRequest$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function HttpRequestRetryConfig$retryOnServerErrors$lambda($this$retryIf, _unused_var__etf5q3, response) {
  // Inline function 'kotlin.let' call
  var it = response.u5k().w54_1;
  return 500 <= it ? it <= 599 : false;
}
var HttpRequestRetryConfigClass;
function HttpRequestRetryConfig() {
  if (HttpRequestRetryConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        tmp.z5s_1 = HttpRequestRetryConfig$delay$slambda_0();
        var tmp_0 = this;
        tmp_0.a5t_1 = HttpRequestRetryConfig$modifyRequest$lambda;
        this.b5t_1 = 0;
        this.c5t(3);
        this.d5t();
      }
      e5t() {
        var tmp = this.w5s_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('shouldRetry');
        }
      }
      f5t() {
        var tmp = this.x5s_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('shouldRetryOnException');
        }
      }
      g5t() {
        var tmp = this.y5s_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('delayMillis');
        }
      }
      h5t(maxRetries, block) {
        if (!(maxRetries === -1))
          this.b5t_1 = maxRetries;
        this.w5s_1 = block;
      }
      i5t(maxRetries, block) {
        if (!(maxRetries === -1))
          this.b5t_1 = maxRetries;
        this.x5s_1 = block;
      }
      j5t(maxRetries, retryOnTimeout) {
        this.i5t(maxRetries, ($this$retryOnExceptionIf, _unused_var__etf5q3, cause) => {
          var tmp;
          if (isTimeoutException(cause)) {
            tmp = retryOnTimeout;
          } else {
            if (cause instanceof CancellationException()) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
          return tmp;
        });
      }
      k5t(maxRetries, retryOnTimeout, $super) {
        maxRetries = maxRetries === VOID ? -1 : maxRetries;
        retryOnTimeout = retryOnTimeout === VOID ? false : retryOnTimeout;
        var tmp;
        if ($super === VOID) {
          this.j5t(maxRetries, retryOnTimeout);
          tmp = Unit_instance;
        } else {
          tmp = $super.j5t.call(this, maxRetries, retryOnTimeout);
        }
        return tmp;
      }
      l5t(maxRetries) {
        this.h5t(maxRetries, HttpRequestRetryConfig$retryOnServerErrors$lambda);
      }
      c5t(maxRetries) {
        this.l5t(maxRetries);
        this.k5t(maxRetries);
      }
      m5t(respectRetryAfterHeader, block) {
        var tmp = this;
        tmp.y5s_1 = (_this__u8e3s4, it) => {
          var tmp;
          if (respectRetryAfterHeader) {
            var tmp0_safe_receiver = _this__u8e3s4.o5t_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y51();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u2o('Retry-After');
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toLongOrNull(tmp2_safe_receiver);
            var tmp_0;
            if (tmp3_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.Long.times' call
              tmp_0 = multiply(tmp3_safe_receiver, fromInt(1000));
            }
            var retryAfter = tmp_0;
            var tmp0 = block(_this__u8e3s4, it);
            // Inline function 'kotlin.comparisons.maxOf' call
            var b = retryAfter == null ? 0n : retryAfter;
            tmp = tmp0 >= b ? tmp0 : b;
          } else {
            tmp = block(_this__u8e3s4, it);
          }
          return tmp;
        };
      }
      q5t(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader) {
        // Inline function 'kotlin.check' call
        if (!(base > 0)) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(baseDelayMs > 0n)) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(maxDelayMs > 0n)) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(randomizationMs >= 0n)) {
          throw IllegalStateException().o('Check failed.');
        }
        this.m5t(respectRetryAfterHeader, ($this$delayMillis, retry) => {
          var tmp0 = base;
          // Inline function 'kotlin.math.pow' call
          var n = retry - 1 | 0;
          var tmp$ret$4 = Math.pow(tmp0, n);
          var tmp0_0 = numberToLong(tmp$ret$4 * toNumber(baseDelayMs));
          // Inline function 'kotlin.comparisons.minOf' call
          var b = maxDelayMs;
          var delay = tmp0_0 <= b ? tmp0_0 : b;
          return add(delay, randomMs(this, randomizationMs));
        });
      }
      d5t(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader, $super) {
        base = base === VOID ? 2.0 : base;
        baseDelayMs = baseDelayMs === VOID ? 1000n : baseDelayMs;
        maxDelayMs = maxDelayMs === VOID ? 60000n : maxDelayMs;
        randomizationMs = randomizationMs === VOID ? 1000n : randomizationMs;
        respectRetryAfterHeader = respectRetryAfterHeader === VOID ? true : respectRetryAfterHeader;
        var tmp;
        if ($super === VOID) {
          this.q5t(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
          tmp = Unit_instance;
        } else {
          tmp = $super.q5t.call(this, base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpRequestRetryConfig', HttpRequestRetryConfig);
    HttpRequestRetryConfigClass = $;
  }
  return HttpRequestRetryConfigClass;
}
var HttpRetryShouldRetryContextClass;
function HttpRetryShouldRetryContext() {
  if (HttpRetryShouldRetryContextClass === VOID) {
    class $ {
      constructor(retryCount) {
        this.r5t_1 = retryCount;
      }
    }
    initMetadataForClass($, 'HttpRetryShouldRetryContext');
    HttpRetryShouldRetryContextClass = $;
  }
  return HttpRetryShouldRetryContextClass;
}
var HttpRetryDelayContextClass;
function HttpRetryDelayContext() {
  if (HttpRetryDelayContextClass === VOID) {
    class $ {
      constructor(request, response, cause) {
        this.n5t_1 = request;
        this.o5t_1 = response;
        this.p5t_1 = cause;
      }
    }
    initMetadataForClass($, 'HttpRetryDelayContext');
    HttpRetryDelayContextClass = $;
  }
  return HttpRetryDelayContextClass;
}
var HttpRetryModifyRequestContextClass;
function HttpRetryModifyRequestContext() {
  if (HttpRetryModifyRequestContextClass === VOID) {
    class $ {
      constructor(request, response, cause, retryCount) {
        this.s5t_1 = request;
        this.t5t_1 = response;
        this.u5t_1 = cause;
        this.v5t_1 = retryCount;
      }
    }
    initMetadataForClass($, 'HttpRetryModifyRequestContext');
    HttpRetryModifyRequestContextClass = $;
  }
  return HttpRetryModifyRequestContextClass;
}
function *throwOnInvalidResponseBody(_this__u8e3s4, $completion) {
  var tmp;
  if (get_isSaved(_this__u8e3s4)) {
    // Inline function 'kotlin.run' call
    var $this$run = _this__u8e3s4.t5k();
    var tmp_0;
    try {
      tmp_0 = yield* $this$run.e4k(VOID, $completion);
    }finally {
      // Inline function 'kotlin.runCatching' call
      var tmp_1;
      try {
        cancel($this$run);
        // Inline function 'kotlin.Companion.success' call
        tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      // Inline function 'kotlin.onFailure' call
      var this_0 = tmp_1;
      var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        get_LOGGER().c4u('Failed to close response body channel', tmp0_safe_receiver);
      }
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
function isTimeoutException(_this__u8e3s4) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var exception = unwrapCancellationException(_this__u8e3s4);
  var tmp;
  var tmp_0;
  if (exception instanceof HttpRequestTimeoutException()) {
    tmp_0 = true;
  } else {
    tmp_0 = exception instanceof ConnectTimeoutException();
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = exception instanceof SocketTimeoutException();
  }
  return tmp;
}
function HttpRequestRetryConfig$_init_$ref_mqbboi() {
  var l = () => new (HttpRequestRetryConfig())();
  l.callableName = '<init>';
  return l;
}
function HttpRequestRetry$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var shouldRetry = $this$createClientPlugin.q5o_1.e5t();
  var shouldRetryOnException = $this$createClientPlugin.q5o_1.f5t();
  var delayMillis = $this$createClientPlugin.q5o_1.g5t();
  var delay = $this$createClientPlugin.q5o_1.z5s_1;
  var maxRetries = $this$createClientPlugin.q5o_1.b5t_1;
  var modifyRequest = $this$createClientPlugin.q5o_1.a5t_1;
  $this$createClientPlugin.w5t(HttpRequestRetry$lambda$slambda_0(maxRetries));
  var tmp = Send_instance;
  $this$createClientPlugin.t5o(tmp, HttpRequestRetry$lambda$slambda_2(shouldRetry, shouldRetryOnException, maxRetries, delayMillis, modifyRequest, $this$createClientPlugin, delay));
  return Unit_instance;
}
function invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call) {
  return retryCount < maxRetries && shouldRetry(new (HttpRetryShouldRetryContext())(retryCount + 1 | 0), call.e5k(), call.e5i());
}
function invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetry, subRequest, cause) {
  return retryCount < maxRetries && shouldRetry(new (HttpRetryShouldRetryContext())(retryCount + 1 | 0), subRequest, cause);
}
function invoke$prepareRequest(request) {
  var subRequest = (new (HttpRequestBuilder())()).x5t(request);
  var tmp = request.r5j_1;
  tmp.gx((cause) => {
    var tmp = subRequest.r5j_1;
    var subRequestJob = isInterface(tmp, CompletableJob()) ? tmp : THROW_CCE();
    if (cause == null) {
      subRequestJob.v12();
    } else {
      subRequestJob.u12(cause);
    }
    return Unit_instance;
  });
  return subRequest;
}
var HttpRequestRetry$lambda$slambdaClass;
function HttpRequestRetry$lambda$slambda() {
  if (HttpRequestRetry$lambda$slambdaClass === VOID) {
    class $ {
      constructor($maxRetries) {
        this.y5t_1 = $maxRetries;
      }
      *z5t($this$onRequest, request, _unused_var__etf5q3, $completion) {
        var tmp0_elvis_lhs = request.s5j_1.m4n(get_MaxRetriesPerRequestAttributeKey());
        var maxRetriesValue = tmp0_elvis_lhs == null ? this.y5t_1 : tmp0_elvis_lhs;
        request.s5j_1.o4n(get_MaxRetriesPerRequestAttributeKey(), maxRetriesValue);
        return Unit_instance;
      }
      a5u(p1, p2, p3, $completion) {
        var tmp = p1 instanceof OnRequestContext() ? p1 : THROW_CCE();
        var tmp_0 = p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE();
        return this.z5t(tmp, tmp_0, !(p3 == null) ? p3 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [3]);
    HttpRequestRetry$lambda$slambdaClass = $;
  }
  return HttpRequestRetry$lambda$slambdaClass;
}
function HttpRequestRetry$lambda$slambda_0($maxRetries) {
  var i = new (HttpRequestRetry$lambda$slambda())($maxRetries);
  var l = ($this$onRequest, request, _unused_var__etf5q3, $completion) => i.z5t($this$onRequest, request, _unused_var__etf5q3, $completion);
  l.$arity = 3;
  return l;
}
var HttpRequestRetry$lambda$slambdaClass_0;
function HttpRequestRetry$lambda$slambda_1() {
  if (HttpRequestRetry$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay) {
        this.b5u_1 = $shouldRetry;
        this.c5u_1 = $shouldRetryOnException;
        this.d5u_1 = $maxRetries;
        this.e5u_1 = $delayMillis;
        this.f5u_1 = $modifyRequest;
        this.g5u_1 = $this_createClientPlugin;
        this.h5u_1 = $delay;
      }
      *h5r($this$on, request, $completion) {
        var retryCount = 0;
        var tmp0_elvis_lhs = request.s5j_1.m4n(get_ShouldRetryPerRequestAttributeKey());
        var shouldRetry = tmp0_elvis_lhs == null ? this.b5u_1 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = request.s5j_1.m4n(get_ShouldRetryOnExceptionPerRequestAttributeKey());
        var shouldRetryOnException = tmp1_elvis_lhs == null ? this.c5u_1 : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = request.s5j_1.m4n(get_MaxRetriesPerRequestAttributeKey());
        var maxRetries = tmp2_elvis_lhs == null ? this.d5u_1 : tmp2_elvis_lhs;
        var tmp3_elvis_lhs = request.s5j_1.m4n(get_RetryDelayPerRequestAttributeKey());
        var delayMillis = tmp3_elvis_lhs == null ? this.e5u_1 : tmp3_elvis_lhs;
        var tmp4_elvis_lhs = request.s5j_1.m4n(get_ModifyRequestPerRequestAttributeKey());
        var modifyRequest = tmp4_elvis_lhs == null ? this.f5u_1 : tmp4_elvis_lhs;
        var call;
        var lastRetryData = null;
        $l$loop: while (true) {
          var subRequest = invoke$prepareRequest(request);
          var tmp;
          try {
            if (!(lastRetryData == null)) {
              var modifyRequestContext = new (HttpRetryModifyRequestContext())(request, lastRetryData.t5s_1, lastRetryData.u5s_1, lastRetryData.s5s_1);
              modifyRequest(modifyRequestContext, subRequest);
            }
            call = yield* $this$on.k5r(subRequest, $completion);
            if (!invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call)) {
              yield* /*#__NOINLINE__*/throwOnInvalidResponseBody(call.e5i(), $completion);
              break $l$loop;
            }
            retryCount = retryCount + 1 | 0;
            tmp = new (HttpRetryEventData())(subRequest, retryCount, call.e5i(), null);
          } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
              var cause = $p;
              if (!invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetryOnException, subRequest, cause)) {
                throw cause;
              }
              retryCount = retryCount + 1 | 0;
              tmp_0 = new (HttpRetryEventData())(subRequest, retryCount, null, cause);
            } else {
              throw $p;
            }
            tmp = tmp_0;
          }
          var retryData = tmp;
          lastRetryData = retryData;
          this.g5u_1.p5o_1.x5h_1.f4u(get_HttpRequestRetryEvent(), lastRetryData);
          var delayContext = new (HttpRetryDelayContext())(lastRetryData.r5s_1, lastRetryData.t5s_1, lastRetryData.u5s_1);
          yield* this.h5u_1(delayMillis(delayContext, retryCount), $completion);
          get_LOGGER().d4u('Retrying request ' + request.n5j_1.toString() + ' attempt: ' + retryCount);
        }
        return call;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof Sender() ? p1 : THROW_CCE();
        return this.h5r(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpRequestRetry$lambda$slambdaClass_0 = $;
  }
  return HttpRequestRetry$lambda$slambdaClass_0;
}
function HttpRequestRetry$lambda$slambda_2($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay) {
  var i = new (HttpRequestRetry$lambda$slambda_1())($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay);
  var l = ($this$on, request, $completion) => i.h5r($this$on, request, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_HttpRequestRetry_kt_jcpv6l;
function _init_properties_HttpRequestRetry_kt__h4xjtt() {
  if (!properties_initialized_HttpRequestRetry_kt_jcpv6l) {
    properties_initialized_HttpRequestRetry_kt_jcpv6l = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestRetry');
    HttpRequestRetryEvent = new (EventDefinition())();
    var tmp = HttpRequestRetryConfig$_init_$ref_mqbboi();
    HttpRequestRetry = createClientPlugin('RetryFeature', tmp, HttpRequestRetry$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'MaxRetriesPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().uf();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().uf(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
    MaxRetriesPerRequestAttributeKey = new (AttributeKey())(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'ShouldRetryPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_3 = PrimitiveClasses_getInstance().functionClass(3);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_4;
    try {
      tmp_4 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequest()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpResponse()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().rf(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_5;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_0 = $p;
        tmp_5 = null;
      } else {
        throw $p;
      }
      tmp_4 = tmp_5;
    }
    var tmp$ret$2_0 = tmp_4;
    var tmp$ret$1_0 = new (TypeInfo())(tmp_3, tmp$ret$2_0);
    ShouldRetryPerRequestAttributeKey = new (AttributeKey())(name_0, tmp$ret$1_0);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_1 = 'ShouldRetryOnExceptionPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_6 = PrimitiveClasses_getInstance().functionClass(3);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_7;
    try {
      tmp_7 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().rf(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_8;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_1 = $p;
        tmp_8 = null;
      } else {
        throw $p;
      }
      tmp_7 = tmp_8;
    }
    var tmp$ret$2_1 = tmp_7;
    var tmp$ret$1_1 = new (TypeInfo())(tmp_6, tmp$ret$2_1);
    ShouldRetryOnExceptionPerRequestAttributeKey = new (AttributeKey())(name_1, tmp$ret$1_1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_2 = 'ModifyRequestPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_9 = PrimitiveClasses_getInstance().functionClass(2);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_10;
    try {
      tmp_10 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryModifyRequestContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit()), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_11;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_2 = $p;
        tmp_11 = null;
      } else {
        throw $p;
      }
      tmp_10 = tmp_11;
    }
    var tmp$ret$2_2 = tmp_10;
    var tmp$ret$1_2 = new (TypeInfo())(tmp_9, tmp$ret$2_2);
    ModifyRequestPerRequestAttributeKey = new (AttributeKey())(name_2, tmp$ret$1_2);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_3 = 'RetryDelayPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_12 = PrimitiveClasses_getInstance().functionClass(2);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_13;
    try {
      tmp_13 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryDelayContext()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().uf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().vf(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_14;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_3 = $p;
        tmp_14 = null;
      } else {
        throw $p;
      }
      tmp_13 = tmp_14;
    }
    var tmp$ret$2_3 = tmp_13;
    var tmp$ret$1_3 = new (TypeInfo())(tmp_12, tmp$ret$2_3);
    RetryDelayPerRequestAttributeKey = new (AttributeKey())(name_3, tmp$ret$1_3);
  }
}
//region block: exports
export {
  get_MaxRetriesPerRequestAttributeKey as get_MaxRetriesPerRequestAttributeKey13gphm9kuo852,
};
//endregion

//# sourceMappingURL=HttpRequestRetry.mjs.map
